/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n(n) {
  var e = n.exifInfo,
      a = n.exifName,
      u = n.tagName;
  if (!e || !a || !u) return null;
  var f = e.find(function (n) {
    return n.name === a;
  });
  return f ? t({
    tagName: u,
    tags: f.tags
  }) : null;
}

function t(n) {
  var t = n.tagName,
      e = n.tags;
  if (!e || !t) return null;
  var a = e.find(function (n) {
    return n.name === t;
  });
  return a && a.value || null;
}

export { n as getExifValue };